import React, { useState, useRef } from 'react';
import { useTranslation } from "react-i18next";

// import api
import { changePassword } from '../../api/users';

// import lib
import { toastAlert } from '../../lib/toastAlert';
import isEmpty from '../../lib/isEmpty';

//import validation
import { changePwdValidate } from './validation';

const initialFormValue = {
  "oldPassword": "",
  "password": "",
  "confirmPassword": ""
}

const initialPassWordIcon = {
  "oldPasswordIcon": false,
  "passwordIcon": false,
  "confirmPasswordIcon": false
}

const ChangePassword = () => {

  const modalRef = useRef();
  const { t, i18n } = useTranslation()


  //state
  const [formValue, setFormValue] = useState(initialFormValue);
  const [passwordIcons, setPasswordIcons] = useState(initialPassWordIcon);
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const { oldPassword, password, confirmPassword } = formValue;
  const { oldPasswordIcon, passwordIcon, confirmPasswordIcon } = passwordIcons;

  //function
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, ... { [name]: value } })
    if (!isEmpty(errors)) {
      setErrors({});
    }
  }

  const handlePassIcon = (name) => setPasswordIcons({ ...passwordIcons, ... { [name]: !passwordIcons[name] } })

  const handleCloseModal = () => {
    setErrors({})
    setFormValue(initialFormValue)
    setPasswordIcons(initialPassWordIcon)
    modalRef.current.click()
  };

  const handleSubmit = async () => {
    try {
      setLoader(true);
      let reqData = {
        oldPassword, password, confirmPassword
      };
      let validationError = changePwdValidate(reqData);
      if (!isEmpty(validationError)) {
        setErrors(validationError);
        setLoader(false);
        return;
      }
      const { status, loading, message, errors } = await changePassword({ oldPassword, password, confirmPassword });
      setLoader(loading);
      if (status === 'success') {
        setLoader(false);
        toastAlert('success', t(message), 'changePassword')
        handleCloseModal()
      } else {
        setLoader(false);
        if (errors) {
          setErrors(errors)
        } else {
          toastAlert('error', t(message), 'changePassword')
        }
      }
    } catch (err) {
      setLoader(false);
      console.log(err, "-error")
    }
  }

  return (
    <div
      className="modal fade primary_modal"
      data-bs-backdrop="static"
      id="changepassword_modal"
      tabindex="-1"
      aria-labelledby="changepassword_modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header justify-between items-center">
           <h1 className="modal-title model_head" id="changepassword_modalLabel">
              {t("CHANGE_PASSWORD")}
            </h1>
            <button
              type="button"
              className="border-0 bg-transparent p-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={modalRef}
              onClick={handleCloseModal}
            >
              <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 0.9375C13.4528 0.9375 17.0625 4.54721 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.54721 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.54721 4.54721 0.9375 9 0.9375ZM7.22315 6.16846C6.92858 5.9282 6.49432 5.94517 6.21973 6.21973C5.94523 6.49432 5.92822 6.9286 6.16846 7.22315L6.21973 7.28027L7.93943 9L6.22046 10.7198C5.92768 11.0126 5.92758 11.4874 6.22046 11.7802C6.51335 12.0729 6.98818 12.073 7.28101 11.7802L9 10.0606L10.719 11.7802L10.7762 11.8316C11.0706 12.0718 11.5049 12.0547 11.7796 11.7802C12.0541 11.5058 12.0716 11.0714 11.8316 10.7768L11.7796 10.7198L10.0598 9L11.7802 7.28027L11.8316 7.22315C12.0718 6.92859 12.0547 6.49432 11.7802 6.21973C11.5057 5.94517 11.0714 5.9282 10.7768 6.16846L10.7198 6.21973L9 7.93943L7.28027 6.21973L7.22315 6.16846Z" fill="#395645" />
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <form className="assets_form">
              <div className="mb-3">
                <label for="oldpassword" className="form-label">
                  {t("OLD_PASSWORD")}
                </label>
                <div className="asset_deposit_grp">
                  <input
                    type={!oldPasswordIcon ? "password" : "text"}
                    className="form-control primary_asset_inp"
                    name="oldPassword"
                    placeholder={t("OLD_PASSWORD_PLACEHOLDER")}
                    value={oldPassword}
                    onChange={handleChange}
                  />
                  <span className="withdrawal_type">
                    <i class={oldPasswordIcon ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"} onClick={() => handlePassIcon('oldPasswordIcon')}></i>
                  </span>
                </div>
                <span className={'text-danger'} >{t(errors?.oldPassword)}</span>
              </div>

              <div className="mb-3">
                <label for="newpassword" className="form-label">
                  {t("NEW_PASSWORD")}
                </label>
                <div className="asset_deposit_grp">
                  <input
                    type={!passwordIcon ? "password" : "text"}
                    className="form-control primary_asset_inp"
                    name="password"
                    placeholder={t("NEW_PASSWORD_PLACEHOLDER")}
                    value={password}
                    onChange={handleChange}
                  />
                  <span className="withdrawal_type">
                    <i class={passwordIcon ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"} onClick={() => handlePassIcon('passwordIcon')}></i>
                  </span>
                </div>
                <span className={'text-danger'} >{t(errors?.password)}</span>
              </div>

              <div className="mb-3">
                <label for="cnewpassword" className="form-label">
                  {t("CONFIRM_PASSWORD")}
                </label>
                <div className="asset_deposit_grp">
                  <input
                    type={!confirmPasswordIcon ? "password" : "text"}
                    className="form-control primary_asset_inp"
                    name="confirmPassword"
                    placeholder={t("CONFIRM_PASSWORD_PLACEHOLDER")}
                    value={confirmPassword}
                    onChange={handleChange}
                  />
                  <span className="withdrawal_type">
                    <i class={confirmPasswordIcon ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"} onClick={() => handlePassIcon('confirmPasswordIcon')}></i>
                  </span>
                </div>
                <span className={'text-danger'} >{t(errors?.confirmPassword)}</span>
              </div>

              <div className="w-full inline-flex justify-start items-center gap-2 mt-4">
                <button type="button"
                    className="flex-1 h-10 px-4 relative bg-gray-300 hover:bg-gray-400 active:bg-gray-500 active:scale-95 transition-all duration-200 rounded-sm flex justify-center items-center overflow-hidden border-0"
                    onClick={handleCloseModal}
                >
                    <div className="text-center justify-center text-[#395645] text-base font-medium font-['Roobert']">{t("CANCEL")}</div>
                </button>
                {
                    loader ?
                        <button type="button" className="flex-1 h-10 px-4 relative bg-[#395645] rounded-sm flex justify-center items-center overflow-hidden border-0 opacity-70 cursor-not-allowed" disabled={true}>
                            <div className="text-center justify-center text-zinc-100 text-base font-medium font-['Roobert']">{t("LOADING")}...</div>
                        </button> :
                        <button type="button" onClick={handleSubmit} className="flex-1 h-10 px-4 relative bg-[#395645] hover:bg-[#2a4033] active:bg-[#1d2d24] active:scale-95 transition-all duration-200 rounded-sm flex justify-center items-center overflow-hidden border-0">
                            <div className="text-center justify-center text-zinc-100 text-base font-medium font-['Roobert']">{t("CHANGE")}</div>
                        </button>
                }
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword;